/**
 * To use HTML tags in 'Additional information' field in admin panel. SC-915
 */
export const createMarkup = (value) => {
    const valueWithoutScript = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, ' ');
    return {
        __html: valueWithoutScript
    };
};
